import type { CssVarsThemeOptions, ThemeOptions } from '@mui/material/styles';

import { accordionTheme } from '../../components/accordion/theme';
import { alertTheme } from '../../components/alert/theme';
import { avatarTheme } from '../../components/avatar/theme';
import { breadcrumbsTheme } from '../../components/breadcrumbs/theme';
import { buttonTheme } from '../../components/button/theme';
import { chipTheme } from '../../components/chip/theme';
import { datagridTheme } from '../../components/datagrid/theme/theme';
import { datePickerTheme } from '../../components/date-pickers/date-picker/theme';
import { dateTimePickerTheme } from '../../components/date-pickers/date-time-picker/theme';
import { timePickerTheme } from '../../components/date-pickers/time-picker/theme';
import { fabTheme } from '../../components/fab/theme';
import { formControlLabelTheme } from '../../components/form-control-label/theme';
import { formHelperTextTheme } from '../../components/form-helper-text/theme';
import { formLabelTheme } from '../../components/form-label/theme';
import { menuItemTheme } from '../../components/menu-item/theme';
import { snackbarTheme } from '../../components/snackbar/theme';
import { stackTheme } from '../../components/stack/theme';
import { tabTheme } from '../../components/tabs/theme';
import { toggleButtonTheme } from '../../components/toggle-button/theme';
import { tooltipTheme } from '../../components/tooltip/theme';
import { typographyTheme } from '../../components/typography/theme';
import { lightPalette, darkPalette, typography, maxWidth } from '../../styles';
import { globals } from '../../styles/theme/globals';

export const themeBase: Omit<ThemeOptions, 'components'> &
  Pick<CssVarsThemeOptions, 'colorSchemes' | 'components'> & {
    cssVariables?:
      | boolean
      | Pick<CssVarsThemeOptions, 'colorSchemeSelector' | 'cssVarPrefix'>;
  } = {
  cssVariables: {
    colorSchemeSelector: 'class',
    cssVarPrefix: 'aw',
  },
  colorSchemes: {
    light: {
      palette: lightPalette,
    },
    dark: {
      palette: darkPalette,
    },
  },
  typography,
  maxWidth,
  components: {
    ...accordionTheme,
    ...alertTheme,
    ...avatarTheme,
    ...breadcrumbsTheme,
    ...buttonTheme,
    ...chipTheme,
    ...datagridTheme,
    ...datePickerTheme,
    ...dateTimePickerTheme,
    ...fabTheme,
    ...formControlLabelTheme,
    ...formHelperTextTheme,
    ...formLabelTheme,
    ...globals,
    ...menuItemTheme,
    ...snackbarTheme,
    ...stackTheme,
    ...tabTheme,
    ...timePickerTheme,
    ...toggleButtonTheme,
    ...tooltipTheme,
    ...typographyTheme,
  },
};
